<template>
  <div class="flex flex-wrap">
    <div class="w-full">
      <div class="relative inline-flex align-middle w-full rounded-lg">
        <div
          class="bg-white text-base z-50 float-left list-none text-left rounded w-full"
          :class="{ hidden: !dropdownPopoverShow, block: dropdownPopoverShow }"
        >
          <div v-if="notifications && notifications.length">
            <div
              v-for="n in notifications"
              :key="n.id"
              class="hover:bg-blue-lightest"
              :class="{ 'opacity-50': n.is_active == INACTIVE }"
              @click="openChat(n.sender_id)"
            >
              <div class="divide-y" v-if="n.type == notificationType">
                <input
                  type="checkbox"
                  :value="n.id"
                  class="hidden"
                  :disabled="n.is_active == INACTIVE ? true : false"
                />
                <NotificationList
                  :title="n.data && n.data.title"
                  :body="n.data && n.data.body"
                  :action="n.data && n.data.action"
                  :thumbnail_url="n.thumbnail_url"
                  :notificationType="n.type"
                  :createdAt="n.created_at"
                />
              </div>
            </div>
          </div>
          <!-- v-if="!isNotification" -->
          <div class="text-center" v-else>No unread messages</div>
          <div class="text-center">
            <router-link
              :to="{ name: 'TrainerMessage' }"
              class="inline-flex items-center h-6 px-4 m-2 text-sm text-green-light transition-colors duration-150 rounded-lg focus:shadow-outline"
              v-if="userType == 'Trainer'"
            >
              <span @click="handleAllMessages"> See All Messages </span>
            </router-link>
            <router-link
              :to="{ name: 'UserMessage' }"
              class="inline-flex items-center h-6 px-4 m-2 text-sm text-green-light transition-colors duration-150 rounded-lg focus:shadow-outline"
              v-if="userType == 'User'"
            >
              <span @click="handleAllMessages"> See All Messages </span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationList from "@/components/notification/NotificationList";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ChatNotificationDropdown",
  components: {
    NotificationList,
  },
  props: {
    userType: {
      type: String,
    },
  },
  data() {
    return {
      dropdownPopoverShow: true,
      notificationType: "sendMessage",
      // isNotification: false,
      INACTIVE: 0,
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  computed: {
    ...mapGetters(["notifications"]),
  },
  methods: {
    ...mapActions(["notificationDestroy", "getNotifications"]),

    openChat(id) {
      if (this.user && this.user.user_type == 1) {
        this.$router.push({ name: "UserMessage", params: { trainer_id: id } });
      } else if (this.user && this.user.user_type == 2) {
        this.$router.push({ name: "TrainerMessage", params: { user_id: id } });
      }
    },

    async handleAllMessages() {
      var array = [];
      var checkboxes = document.querySelectorAll(
        "input[type=checkbox]:enabled"
      );

      for (var i = 0; i < checkboxes.length; i++) {
        array.push(checkboxes[i].value);
      }
      if (array.length) {
        await this.notificationDestroy({ ids: array });
        await this.getNotifications();
      }
      this.$emit("onClose");
    },
  },
  async created() {
    if (this.getToken()) {
      await this.getNotifications();
    }
    // for (let i in this.notifications) {
    //   if (this.notifications[i].type == this.notificationType) {
    //     this.isNotification = true;
    //   }
    // }
  },
};
</script>